import { IStyleConfig, mergeStyles } from '@cian/utils';
import * as PropTypes from 'prop-types';
import * as React from 'react';

import { UserInfoPopup } from '../../common/components/user-info-popup/';
import { IOfferHelper } from '../../presenter';
import { IOffer } from '../../types/offer';
import { IUser } from '../../types/user';
import { isAgentBrandShow as getIsAgentBrandShow, isDealAndProfi } from './helpers';
import { UserInfoVertical } from './UserInfoVertical';
import { UserInfoHorizontal } from './UserInfoHorizontal';
import * as style from './index.css';

export type TUserInfoType = 'vertical' | 'horizontal';

export interface IUserInfoProps {
  containerStyle?: IStyleConfig;
  type?: TUserInfoType;
}

export interface IUserInfoContext {
  offerHelper: IOfferHelper;
  offer: IOffer;
  user: IUser;
}

export class UserInfo extends React.Component<IUserInfoProps> {
  public context: IUserInfoContext;

  public static contextTypes = {
    offer: PropTypes.object,
    offerHelper: PropTypes.object,
    user: PropTypes.object,
  };

  public static defaultProps = {
    type: 'vertical' as TUserInfoType,
  };

  public render() {
    const isVertical = this.props.type === 'vertical';

    const { offer, offerHelper, user } = this.context;
    const { isTop3, isByHomeowner } = offer;
    const { tariff } = user;

    const isFromBuilder = offerHelper.isFromBuilder();
    const isFromSeller = offerHelper.isFromSeller();
    const agentAvatarUrl = offerHelper.presenters.getAvatarUrl();
    const userTrustLevel = offerHelper.presenters.getUserTrustLevel();
    const isRepresentative = !!(offer.businessShoppingCenter && offer.businessShoppingCenter.fromRepresentative);
    const userPersonalRating = offerHelper.presenters.getUserPersonalRating();
    const accountType = offerHelper.presenters.getAccountType();
    const isAgentBrandShow = getIsAgentBrandShow(offer, userTrustLevel);
    const isShowLabelOfAccountType = isDealAndProfi(tariff, accountType);

    if (
      !isAgentBrandShow &&
      !isFromBuilder &&
      !isFromSeller &&
      !isByHomeowner &&
      !isRepresentative &&
      !isShowLabelOfAccountType &&
      !userPersonalRating
    ) {
      return <div />;
    }

    const avatar = isAgentBrandShow && isTop3 && agentAvatarUrl && isVertical && (
      <div className={`${style['userAvatar']}`}>
        <img src={`${agentAvatarUrl.replace(/(p=\d)$/g, 'p=1')}`} />
      </div>
    );

    const content = isVertical ? <UserInfoVertical /> : <UserInfoHorizontal />;

    return (
      <UserInfoPopup
        avatar={avatar}
        content={content}
        containerStyle={mergeStyles(
          isVertical ? style['container'] : style['containerHorizontal'],
          this.props.containerStyle,
        )}
        userInfoStyle={mergeStyles(!isVertical && style['userInfo--horizontal'])}
      />
    );
  }
}
